import HttpClientToken from '../../services/HttpClientToken';

import { defaultDistritoJudicial, DistritoJudicialProps } from '../../interfaces/catalogos/DistritoJudicialInterface';

export const ObtenerDistritoJudicial = () => {

    return new Promise<DistritoJudicialProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/DistritoJudicial/ObtenerDistritoJudicial', token)
            .then( ({ data } : { data : DistritoJudicialProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const DistritoJudicial = () => {

    return new Promise<DistritoJudicialProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/DistritoJudicial/', token)
            .then( ({ data } : { data : DistritoJudicialProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarDistritoJudicial = ( params: DistritoJudicialProps ) => {

    return new Promise<DistritoJudicialProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/DistritoJudicial/Actualizar', params, token)
            .then( ({ data } : { data : DistritoJudicialProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDistritoJudicial } );
            });

        }

    });

}

export const AgregarDistritoJudicial = ( params: DistritoJudicialProps ) => {

    return new Promise<DistritoJudicialProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/DistritoJudicial/Agregar', params, token)
            .then( ({ data } : { data : DistritoJudicialProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDistritoJudicial } );
            });

        }

    });

}
